import React from 'react'
import { Col, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { URL } from '../../api';

const ChargingSystem = ({ data }) => {
    const lang = useSelector((state) => state.lang.lang)

    return (
        <div className='product-families'>
            <div className='d-flex justify-content-center align-items-center mt-3'>
                <div><strong className='f40 fw500 color8'>{data?.modules[0]?.title[lang]}</strong></div>
            </div>
            <div className='d-flex justify-content-center align-items-center m-3'>
                <div className="product-span"><span className='f20 fw500 color9 '>{data?.modules[0]?.description[lang]}</span></div>
            </div>
            <Row className='product-families-content justify-content-center'>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="item d-flex justify-content-center align-items-center">
                    <img src={`${URL}${data?.modules[0]?.files[0]}`} alt="" className="home-charge" loading="lazy" />
                </Col>
            </Row>
        </div>
    )
}

export default ChargingSystem
